import axios from "axios";
import * as actionType from "../../constant/actionType";
import { fetchData,fetchDataSuccess, fetchDataError } from "../../redux/classes/client-portal/getAllDoctype";
export const GetAllDocType = (getAllinvitedData) => async (dispatch) => {
    /*** API Call Action ***/
    try {
      dispatch(fetchData());
      const response = await axios({
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('conserve_authtoken')}`,
        },
        url: `${actionType.environment_url}/api/admin/provider/GetAllDocumentTypeList`,
        params: getAllinvitedData
      });
      dispatch(fetchDataSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(fetchDataError(error.message));
      return error.message;
    }
  };